import React from 'react'
import LinkRounded from '../../../components/LinkRounded'
import { Text } from 'rebass'
import { Link } from '../../../setup/stubs'
import ContentBannerSignPost from '../../../components/ContentBannerSignPost'
import typography from '../../../utils/typography'
import buildImageUrl from '../../../../lib/media-url-maker'

const SectionPromoWidget = ({
  images,
  title,
  sell,
  callToActionText,
  callToActionLink
}) => {
  const image = images.widgets[0].crops[0].src
  const imgs = {
    x1: buildImageUrl({
      width: 514,
      resource: image
    }),
    x2: buildImageUrl({
      width: 1028,
      resource: image
    })
  }
  let to = null
  let href = null
  if (/^(https?|tel|mailto):\/\//.test(callToActionLink)) {
    href = callToActionLink
  } else {
    to = callToActionLink
  }
  return (
    <ContentBannerSignPost title={title} img={imgs}>
      <Text f={[3, 4, 5]} mb={typography.rhythm(1.5)}>
        {sell}
      </Text>
      <LinkRounded
        to={to}
        href={href}
        Link={Link}
        rel="noopener"
        target="_blank"
        shadow
        reversed
      >
        {callToActionText}
      </LinkRounded>
    </ContentBannerSignPost>
  )
}
export default SectionPromoWidget
